import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "session_token";

export function getStoredToken() {
  try { return localStorage.getItem(TOKEN_KEY) || ""; } catch (_) { return ""; }
}
export function setStoredToken(tk) {
  try { tk ? localStorage.setItem(TOKEN_KEY, tk) : localStorage.removeItem(TOKEN_KEY); } catch (_) {}
}

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Send Authorization: Bearer <token> as a fallback for environments where
// 3rd-party cookies are blocked (custom domain pointing to a separate API host).
api.interceptors.request.use((config) => {
  const tk = getStoredToken();
  if (tk && !config.headers?.Authorization) {
    config.headers = { ...(config.headers || {}), Authorization: `Bearer ${tk}` };
  }
  return config;
});

export function fileUrl(pathOrUrl) {
  if (!pathOrUrl) return "";
  if (pathOrUrl.startsWith("http")) return pathOrUrl;
  if (pathOrUrl.startsWith("/api/")) return `${BACKEND_URL}${pathOrUrl}`;
  return `${API}/files/${pathOrUrl}`;
}
